import {NgModule} from '@angular/core';
import {ContentModalDirective} from "./content-modal.directive";

@NgModule({
    declarations: [
        ContentModalDirective,
    ],
    exports: [
        ContentModalDirective,
    ],
})
export class ContentModalModule {}
